// extracted by mini-css-extract-plugin
export var bgP = "itemDetail-module--bgP--rtpm4";
export var content = "itemDetail-module--content--QKUi3";
export var header = "itemDetail-module--header--OCeSw";
export var img = "itemDetail-module--img--0hN4q";
export var imgContainer = "itemDetail-module--imgContainer--DAkgR";
export var li = "itemDetail-module--li--a3wpr";
export var rootContainer = "itemDetail-module--rootContainer--iyBYO";
export var textOverflow = "itemDetail-module--textOverflow--4h0Wq";
export var ul = "itemDetail-module--ul--E8f7q";